
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import ParcelamentoData, {
  localizarOpcaoPorId,
  meioPagamentoPermiteTaxaAdministracao,
  ParcelamentoDataRequired,
} from "./ParcelamentoData";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import Plus from "vue-material-design-icons/PlusThick.vue";
import TableApp from "@/components/Table/Table3.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";

export default {
  name: "app-parcelamentos-form",
  props: {
    url: {
      type: String,
    },
    parcelamento: {
      type: Object,
      default: () => { },
    },
  },
  components: {
    VueSelect,
    Plus,
    TableApp,
    TrashCanIcon,
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      intervalos: [],
      intervaloSelected: null,
      meiosPagamentos: [],
      intervalo_dias_collection: [],
      intervaloDiasToAdd: null,
      meioPagamentosSelected: null,
      windowWidth: window.innerWidth,
      form: new ParcelamentoData({}),
      bancos: [],
      planosContasTaxa: [],
      planoContasTaxaSelected: null,
      fields: [
        {
          label: "Intervalo (Dias)",
          field: "dias",
          sortable: false,
          slot: true,
        },
        {
          label: "",
          field: "actions",
          sortable: false,
          slot: true,
          width: "10%",
        },
      ],
    };
  },
  validations: {
    form: ParcelamentoDataRequired,
  },
  watch: {
    parcelamento: {
      immediate: true,
      handler(newValue) {
        if (!newValue || !Object.keys(newValue).length) {
          return;
        }

        this.form = { ...newValue };
        this.intervalo_dias_collection = newValue.intervalo_dias_collection || [];
        this.sincronizarCamposSelecionados();
      },
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
    exibirTaxaAdministracao() {
      return meioPagamentoPermiteTaxaAdministracao(
        this.form.id_meio_pagamento
      );
    },
    exibirPlanoContasTaxa() {
      return this.exibirTaxaAdministracao && Number(this.form.taxa) > 0;
    },
  },
  created() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
 async mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
    const bancos = await this.getBancosByEmpresa();

    this.bancos = bancos;
  },
  methods: {
    ...mapActions(["setLoading"]),
    sincronizarCamposSelecionados() {
      this.meioPagamentosSelected = localizarOpcaoPorId(
        this.meiosPagamentos,
        this.form.id_meio_pagamento
      ) || this.form.meio_pagamento || null;

      const idIntervalo = this.form.tipo_repeticao
        || (this.form.intervalo_dias && this.form.intervalo_dias.id);

      this.intervaloSelected = localizarOpcaoPorId(
        this.intervalos,
        idIntervalo
      ) || this.form.intervalo_dias || null;

      this.planoContasTaxaSelected = localizarOpcaoPorId(
        this.planosContasTaxa,
        this.form.id_plano_contas_taxa
      ) || this.form.plano_contas_taxa || null;
    },
    removeInterval(index) {
      this.intervalo_dias_collection.splice(index, 1);
      this.form.vezes = this.intervalo_dias_collection.length;
    },
    changeDiaValue(e, rowData) {
      const aux = _.cloneDeep(this.intervalo_dias_collection);
      aux.splice(rowData.originalIndex, 1, {
        dias: e
      })
      this.intervalo_dias_collection = aux;
    },
    addInterval() {
      this.intervalo_dias_collection.push({
        dias: parseInt(this.intervaloDiasToAdd)
      })
      this.intervaloDiasToAdd = null;
      this.form.vezes = this.intervalo_dias_collection.length;
    },
    setIntervalo(intervalo) {
      this.form.tipo_repeticao = intervalo.id;
      if (intervalo.id !== 9) {
        this.intervalo_dias_collection = [];
        this.form.vezes = null;
      }
    },
    setMeioPagamento(meioPagamento) {
      this.form.id_meio_pagamento = meioPagamento ? meioPagamento.id : null;

      if (!this.exibirTaxaAdministracao) {
        this.form.taxa = null;
        this.setPlanoContasTaxa(null);
      }
    },
    onTaxaInput() {
      if (Number(this.form.taxa) <= 0) {
        this.setPlanoContasTaxa(null);
      }
    },
    setPlanoContasTaxa(planoContas) {
      this.planoContasTaxaSelected = planoContas;
      this.form.id_plano_contas_taxa = planoContas ? planoContas.id : null;
      this.form.plano_contas_taxa = planoContas;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    resetInputs() {
      this.quantidade = 1;
      this.preco = 0;
      this.total = 0;
    },

    async getDataInit() {
      this.setLoading(true)
      try {
        const [
          { data: intervaloData },
          { data: meiosPagamentoData },
          planosContasTaxa,
        ] = await Promise.all([
          this.$http.post('/financeiro/get-tipo-intervalo'),
          this.$http.post('/financeiro/meios-pagamento'),
          this.getPlanoContas(1),
        ])
        this.intervalos = intervaloData;
        this.meiosPagamentos = meiosPagamentoData;
        this.planosContasTaxa = planosContasTaxa;
        this.sincronizarCamposSelecionados();
      } catch (error) {
        console.log(error);
      }
      this.setLoading(false)
    },
    async onSubmit() {
      this.addLoadingToButton('subit_novo_parcelamento');
      try {
        await this.$http.post(this.url, {
          ...this.form,
          ...(this.form.tipo_repeticao === 9 && { intervalo_dias_collection: this.intervalo_dias_collection })
        });
        this.$router.push({ name: "parcelamentos" });
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton('subit_novo_parcelamento')
    },
  },
};
